const setLocalStorageWithExpiry = (key, expirationInMinutes) => {
    const now = new Date();
    const expirationTime = now.getTime() + (expirationInMinutes * 60 * 1000);
    window.localStorage.setItem(key, expirationTime);
};

const getLocalStorageWithExpiry = (key) => {
    const expirationTime = window.localStorage.getItem(key);
    const now = new Date();
    if (now.getTime() > expirationTime) {
        window.localStorage.removeItem(key);
        return null;
    }
    return key;
};

export { setLocalStorageWithExpiry, getLocalStorageWithExpiry };
